import { render, staticRenderFns } from "./selectGradeModal.vue?vue&type=template&id=28633c38&scoped=true&"
import script from "./selectGradeModal.vue?vue&type=script&lang=js&"
export * from "./selectGradeModal.vue?vue&type=script&lang=js&"
import style0 from "./selectGradeModal.vue?vue&type=style&index=0&id=28633c38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28633c38",
  null
  
)

export default component.exports